<template>
  <div>
    <div v-if="Object.keys(errors).length > 0" class="alert alert-danger">
      <p v-for="error in errors" class="errors">
        {{ error }}
      </p>
    </div>
    <div v-if="config.oldEnrollment" :class="{'has-error':errors.declinedMessage}">
      <label>Show declined message:</label>
      <textarea :value="declinedMessage" name="declinedMessage" class="form-control" @input="handleChange" />
    </div>
    <div v-else>
      <label>Define declined message on the Enrollment Setting tab</label>
    </div>
  </div>
</template>
<script>
  import BaseComponent from '@/EventLogic/components/BaseComponent.vue';

  export default {
    extends: BaseComponent,

    props: {
      declinedMessage: String,
      id: String
    },
    methods: {
      validate: function() {
        // Old enrollment has a configurable message, new enrollment does not
        if (!this.config.oldEnrollment) {
          return true;
        }

        this.errors = {};

        if (!this.declinedMessage) {
          this.errors.declinedMessage = "Please enter incident text.";
        }

        return Object.keys(this.errors).length === 0;
      }
    }
  };
</script>
